/*
[
    [ "Sex-Shop", "c" ],
    [ "Acessorios", "c" ],
    [ "de-20-a-30", "priceFrom" ],
    [ "3R-IMPORT", "b" ],
    [ "Preto", "specificationFilter_24" ]
]
*/

// /categoria/marca/campo-produto (ordenado do menor pro maior)

const ORDER = ['c', 'b', 'productClusterIds', 'priceFrom']
const specificationFilterNumber = (s: string) => s.match(/specificationFilter_(\d+)/)?.[1]

export default function (url: string) {
    const URLi = new URL(url.startsWith('http') ? url : `https://localhost${url}`)

    const map = decodeURIComponent(URLi.searchParams.get('map') || '').split(',')
    const paths = URLi.pathname.split('/').filter(Boolean)

    const urlMap = map
        .reduce((acc, curr, i) => {
            const isBrandOrCategory = curr === 'b' || curr === 'c'

            return [...acc, [isBrandOrCategory ? paths[i].toLowerCase() : paths[i], curr]]
        }, [] as string[][])
        .sort((a, b) => {
            const specificationA = specificationFilterNumber(a[1])
            const specificationB = specificationFilterNumber(b[1])

            if (specificationA && specificationB) {
                if (specificationA < specificationB) return -1
                if (specificationA > specificationB) return 1
            }

            if (specificationA && !specificationB) {
                if (b[1] === 'priceFrom') return -1
                return 1
            }

            if (!specificationA && specificationB) {
                if (a[1] === 'priceFrom') return 1
                return -1
            }

            const aIndex = ORDER.indexOf(a[1])
            const bIndex = ORDER.indexOf(b[1])
            if (aIndex === -1 && bIndex === -1) return 0

            if (aIndex < bIndex) return -1
            if (aIndex > bIndex) return 1

            return 0
        })

    URLi.pathname = urlMap.map(([path]) => path).join('/')
    URLi.searchParams.set('map', urlMap.map(([, param]) => param).join(','))

    return URLi.pathname + URLi.search + URLi.hash
}
